/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Url_WebSocket_BuildUrl } from "app/rest-constants";
import { Subject } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { WebSocketService } from "./websocket.service";

/**
 * Service used to create "Monitor Location" Web Socket connections.
 * These connections are currently used by the "Monitor Location" Page Component
 * to listen for the following events if they occur in the selected Location:
 *   1) Asset Entered Location
 *   2) Asset Exited Location
 *   3) Asset Entered Zone
 *   4) Asset Exited Zone
 *   5) Person Entered Location
 *   6) Person Exited Location
 *   7) Person Entered Zone
 *   8) Person Exited Zone
 */
@Injectable()
export class MonitorLocationWebSocketService {

  /**
   * Constructor
   */
  constructor(
    private authenticationService: AuthenticationService,
    private webSocketService: WebSocketService
  ) { }

  /**
   * Creates the Web Socket connection to the "Monitor Location" Web Socket API
   * for the Location with the given ID and returns the Subject that can be used
   * to interact with it. 
   */
  public create(locationInstanceId: number): Subject<MessageEvent> {
    // Get information required to build URL...
    const authToken = this.authenticationService.getToken();

    // Build the URL...
    const url = Url_WebSocket_BuildUrl(authToken, `monitor-location/${locationInstanceId}`);

    // Create the Web Socket connection / subscription and return it...
    return this.webSocketService.connect(url);
  }

}
